import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useLoadMore from "hooks/useLoadMore";
import { useState } from "react";
import MenuPriceSetting from "components/menu/MenuPriceSetting";
import TableWheelBrand from "../components/TableWheelBrand";
import useWheelBrand from "../hooks/useWheelBrand";
import WheelBrandDetailModal from "../components/WheelBrandDetailModal";
import WheelImagesDetailModal from "../components/WheelImagesDetailModal";
import { TUploadImageType, WheelBrandListItem } from "../types/wheel-brand";

/**
 * Component for setting processing fees.
 */
function WheelBrand() {
  const navigate = useNavigate();
  const [showWheelModal, setShowWheelModal] = useState({ main: false, detail: false });

  const {
    wheelBrandList,
    wheelItemPriceSelected,
    setWheelItemPriceSelected,
    handleUpdateBrand,
    handleDeleteImage,
    handleUploadImages,
    onLoadMore,
    loading,
  } = useWheelBrand();
  const { renderNodeLoader } = useLoadMore(onLoadMore, loading);

  const handleOpenModal = (type: TUploadImageType, item: WheelBrandListItem) => {
    setWheelItemPriceSelected(item);
    setShowWheelModal((prev) => ({ ...prev, [type]: true }));
  };

  const handleCloseModal = (type: TUploadImageType) => {
    setShowWheelModal((prev) => ({ ...prev, [type]: false }));
    setWheelItemPriceSelected(null);
  };

  return (
    <>
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate("/")} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          columnGap: { xs: 0, lg: 10 },
          p: { xs: 2, md: 2.5, lg: 5 },
        }}
      >
        <Box
          sx={{
            display: { xs: "flex", xl: "block" },
            justifyContent: "space-between",
            width: { xs: "100%", xl: "290px" },
          }}
        >
          <Typography
            variant="h5"
            margin={0}
            textAlign="left"
            fontSize={{ xs: 24, md: 28, lg: 23 }}
            marginBottom="50px"
            color="var(--gray-600)"
            minWidth={{ xs: 300, lg: 0 }}
          >
            <span style={{ fontSize: "33px" }}>マスタ管理</span> <br />
            <span style={{ fontSize: "28px" }}>売価設定</span> <br />
            <span style={{ fontSize: "28px", marginLeft: "20px" }}>ホイール売価設定</span> <br />
            <span style={{ fontSize: "28px", marginLeft: "20px" }}>冬ホイールセット</span>
          </Typography>
          <MenuPriceSetting />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            mx: { xs: 0, xl: "auto" },
            flex: 1,
            width: { xs: "100%", lg: "calc(100% - 290px)" },
          }}
        >
          <Box sx={{ marginBottom: { xs: 3, md: 5, lg: 8 } }}>
            <Typography
              sx={{ fontSize: { xs: 18, xl: 25 } }}
              variant="h5"
              fontSize="25px"
              color="var(--gray-600)"
              fontWeight="medium"
              marginBottom="12px"
            >
              ホイール売価設定
            </Typography>
            <Typography
              variant="h2"
              fontSize="35px"
              color="var(--black)"
              fontWeight="regular"
              sx={{ fontSize: { xs: 20, md: 24, xl: 35 } }}
            >
              ホイールの売価設定を行います
            </Typography>
          </Box>
          <Box sx={{ overflowX: "auto", width: { xs: "100%", lg: "auto" } }}>
            <TableWheelBrand
              wheelBrands={wheelBrandList}
              onUpdate={handleUpdateBrand}
              openModal={handleOpenModal}
            />
            {renderNodeLoader()}
          </Box>
        </Box>
      </Box>

      {showWheelModal.main && wheelItemPriceSelected && (
        <WheelBrandDetailModal
          showWheelImgModal={showWheelModal.main}
          wheelItemPriceSelected={wheelItemPriceSelected}
          handleClose={() => handleCloseModal("main")}
          onDeleteImage={handleDeleteImage}
          onUploadImage={handleUploadImages}
        />
      )}

      {showWheelModal.detail && wheelItemPriceSelected && (
        <WheelImagesDetailModal
          showWheelImgModal={showWheelModal.detail}
          handleClose={() => handleCloseModal("detail")}
          wheelItemPriceSelected={wheelItemPriceSelected}
          onDeleteImage={handleDeleteImage}
          onUploadImage={handleUploadImages}
        />
      )}
    </>
  );
}

export default WheelBrand;
